import React from 'react';
import { Table, Typography, Radio, Input, Pagination } from "antd";
import { COLORS } from './utils/Constants';
import IdUpdateModal from './IdUpdateModal';
import { validateEmail, getMmmHhMmDate, getIdentitiesListApi, getUserIdentitiesListApi, 
  getIdentitiesPageSizeApi, getUserIdMediaLinksApi } from './utils/ApiUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faMoneyBillWave, faUniversity } from '@fortawesome/free-solid-svg-icons'

const { Text } = Typography;
const { Search } = Input;
// 4 - Pending , 5 - Passed , 6 - Rejected
const stateArray = ["All", "Pending", "Passed", "Rejected"];
let currentObj = '', modalNumber = 0;
const yellowColor = '#ffcc00', whiteColor = '#a6b2d1', redColor = '#FF8888', greenColor = '#8DCB4F';

export default class IdentitiesTab extends React.Component {
  
  state = { radioValue: 1, movieText: 'Select Your Movie', businessObj: '', movieObj: '', isVerified: false, 
  identityList: [], extraInfo: '', radioValue: 1, message: '', showModal: false, pageNumber: 1, pageSize: 1 };

  columns = [
    {
        title: 'No.',
        dataIndex: 'number',
        sorter: (a, b) => a.number - b.number,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: (text, record) => (
            <Text style={{ whiteSpace: 'break-spaces' }}>{getMmmHhMmDate(text)}</Text>
        ),
        sorter: (a, b) => a.date - b.date,
    },
    {
        title: 'Email',
        dataIndex: 'email',
    },
    {
      title: 'Location',
      dataIndex: 'location',
    },
    {
      title: 'IP Address',
      dataIndex: 'ipaddress',
    },
    {
        title: 'ID Docs',
        dataIndex: 'docs',
        render: (text, record) => (
            <div>
                { text.ID_FRONT
                ?
                <div>
                    <a href={text.ID_FRONT} target='_blank' rel="noopener noreferrer">[Front]</a>
                    <a href={text.ID_BACK} target='_blank' rel="noopener noreferrer"> [Back] </a>
                    <a href={text.ID_VIDEO} target='_blank' rel="noopener noreferrer">[Selfie]</a>
                </div>
                :
                <div style={{ cursor: 'pointer', color: whiteColor }} onClick={() => { this.fetchUserMedia(record.email, record.number) }}>
                  {text}
                </div>
                }
            </div>
        ),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: (text, record) => {
          return {
            props: {
              style: { backgroundColor: record.bgColor }
            },
            children: (
              <div style={{ cursor: 'pointer' }} onClick={() => { this.showModalFn(record) }}>
              <Text style={{ whiteSpace: 'break-spaces' }}>{text}</Text>
              </div>
            )
          };
        },
    },
    {
        title: 'Notes',
        dataIndex: 'notes',
    },
    {
        title: 'Manually Verified?',
        dataIndex: 'verified',
    }
  ];

  showModalFn = object => {
    modalNumber = object.number;
    console.log('show modal number='+modalNumber);
    currentObj = this.state.identityList[modalNumber];
    this.setState({ showModal: true });
  };

  closeIdModal = () => {
    this.setState({ showModal: false });
  }

  componentDidMount() {
    this.fetchPageSize(stateArray[0]);
    this.fetchIdentities(stateArray[0], 1);
  }

  fetchIdentities = (state, pageNumber) => {
    let sessionValue = this.props.sessionValue;
    console.log('sessionValue='+sessionValue);
    this.props.showHideLoader(true);
    getIdentitiesListApi(sessionValue, state, pageNumber)
      .then(response => {
        this.props.showHideLoader(false);
        console.log('Identities List='+JSON.stringify(response.info));
        if(response.ok) {
          this.createListForTable(response.info);
        } else {
          console.log('Identities List failed!');
          this.setState({ identityList: [], message: 'No Identities available' });
        }
      })
      .catch((error) => {
        console.log('Error getting Identities List='+JSON.stringify(error));
        this.props.showHideLoader(false);
        this.setState({ identityList: [], message: 'No Identities available' });
      });
  }

  fetchPageSize = (state) => {
    let sessionValue = this.props.sessionValue;
    console.log('sessionValue='+sessionValue);
    getIdentitiesPageSizeApi(sessionValue, state)
    .then(response => {
      console.log('Page size='+JSON.stringify(response.info));
      if(response.ok) {
        this.setState({ pageSize: response.info });
      } else {
        console.log('Page size failed!');
        this.setState({ pageSize: 1 });
      }
    })
    .catch((error) => {
      console.log('Error getting Page size='+JSON.stringify(error));
      this.setState({ pageSize: 1 });
    });
  }

  createListForTable = (tempIdList) => {
      let newIdList = [];
      for(let i=0; i<tempIdList.length; i++) {
        let tempObject = tempIdList[i];
        let newObj = { 'number': i, 'id': tempObject.id };
        newObj['date'] = tempObject.updatedTime;
        if(tempObject.user) {
          newObj['email'] = tempObject.user.emailAddress;
          newObj['ipaddress'] = tempObject.user.currentIPAddress;
          newObj['location'] = tempObject.user.location.city+', '+tempObject.user.location.country;
        }
        newObj['identityMatchStatusId'] = tempObject.identityMatchStatusId;
        newObj['bgColor'] = tempObject.identityMatchStatusId==5 ? greenColor : (tempObject.identityMatchStatusId==6 ? redColor : yellowColor);
        newObj['docs'] = tempObject.mediaLinks&&tempObject.mediaLinks.ID_FRONT ? tempObject.mediaLinks : '[Fetch All Documents]';
        newObj['status'] = 'LabelMatch : '+(tempObject.labelMatchPercentage).toFixed(2)+'\nFaceMatch : '+tempObject.faceMatchPercentage.toFixed(2);
        newObj['notes'] = tempObject.modifiedByUser ? 'Manually verified by '+tempObject.modifiedByUser+' at '+getMmmHhMmDate(tempObject.verifiedTime) : 'Not available';
        newObj['verified'] = tempObject.manuallyVerified ? 'Yes' : 'No';
        newIdList.push(newObj);
      }
      if(newIdList.length>0) {
        this.setState({ identityList: newIdList, message: '' });
      } else {
        this.setState({ identityList: [], message: 'No Identities available' });
      }
      console.log('Identities List table='+JSON.stringify(newIdList));
  }

  updateSingleIdentity = (newObject) => {
    if(this.state.radioValue==1) {
      let currentIdList = this.state.identityList;
      let updatedObj = currentIdList[modalNumber];
      let statusId = newObject.identityMatchStatusId;
      updatedObj['identityMatchStatusId'] = statusId;
      updatedObj['bgColor'] = statusId==5 ? greenColor : (statusId==6 ? redColor : yellowColor);
      updatedObj['notes'] = newObject.modifiedByUser ? 'Manually verified by '+newObject.modifiedByUser+' at '+getMmmHhMmDate(newObject.verifiedTime) : 'Not available';
      updatedObj['verified'] = newObject.manuallyVerified ? 'Yes' : 'No';
      currentIdList[modalNumber] = updatedObj;
      console.log('new list='+JSON.stringify(currentIdList));
      this.setState({ identityList: currentIdList });
    } else {
      let currentIdList = [...this.state.identityList];
      currentIdList.splice(modalNumber, 1);
      if(currentIdList.length>0) {
        this.setState({ identityList: currentIdList });
      } else {
        this.setState({ identityList: [], message: 'No Identities available' });
      }
    }
  }

  onSearch = value => {
    let isEmail = validateEmail(value);
    if(isEmail) {
      let sessionValue = this.props.sessionValue;
      let currentState = stateArray[this.state.radioValue-1];
      console.log('search value='+value+' currentState='+currentState+' sessionValue='+sessionValue);
      this.props.showHideLoader(true);
      getUserIdentitiesListApi(sessionValue, value, currentState)
        .then(response => {
          this.props.showHideLoader(false);
          console.log('Identities List='+JSON.stringify(response.info));
          if(response.ok) {
            this.setState({ pageNumber: 1, message: '' });
            this.createListForTable(response.info);
          } else {
            console.log('Identities List failed!');
            this.setState({ identityList: [], message: 'No Identities available' });
          }
        })
        .catch((error) => {
          console.log('Error getting Identities List='+JSON.stringify(error));
          this.props.showHideLoader(false);
          this.setState({ identityList: [], message: 'No Identities available' });
        });
    } else {
      let isEmpty = !value || value == undefined || value == "" || value.length == 0;
      if(isEmpty) {
        let currentState = stateArray[this.state.radioValue-1];
        this.fetchIdentities(currentState, this.state.pageNumber);
      }
    } 
  }

  fetchUserMedia = (email, index) => {
    this.props.showHideLoader(true);
    let sessionValue = this.props.sessionValue;
    getUserIdMediaLinksApi(sessionValue, email)
    .then(response => {
      this.props.showHideLoader(false);
      console.log('Identities List='+JSON.stringify(response.info));
      if(response.ok) {
        this.updateUserMedia(response.info, index);
      } else {
        console.log('Identities List failed!');
        this.updateUserMedia('Fetching Docs Failed!', index);
      }
    })
    .catch((error) => {
      console.log('Error getting Identities List='+JSON.stringify(error));
      this.props.showHideLoader(false);
      this.updateUserMedia('Fetching Docs Failed!', index);
    });
  }

  updateUserMedia = (newObject, index) => {
      let currentIdList = this.state.identityList;
      let updatedObj = currentIdList[index];
      updatedObj['docs'] = newObject;
      currentIdList[index] = updatedObj;
      console.log('new list='+JSON.stringify(newObject)+' index='+index);
      this.setState({ identityList: currentIdList });
  }

  onChangeRadio = e => {
    let key = e.target.value;
    console.log('radio4 checked key='+key);
    this.setState({ radioValue: key, pageNumber: 1 });
    this.fetchIdentities(stateArray[key-1], 1);
  }

  onPageChange = p => {
    console.log('page change='+p);
    let currentState = stateArray[this.state.radioValue-1];
    this.fetchIdentities(currentState, p);
    this.setState({ pageNumber: p });
  }
  
  render() {
    let { identityList, message, showModal, radioValue, pageNumber, pageSize } = this.state;
    let tabHeight = window.innerHeight - 216;
    return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row',margin: 40, marginTop: 0 }}>
        <div style={{ display: "flex", alignItems: "center", width: '100%', textAlign: 'center' }}>
            <Radio.Group onChange={this.onChangeRadio} className='manageMovie' size='large' defaultValue={radioValue} buttonStyle="solid">
                <Radio.Button className="rad1 radioNew" value={1}>
                    <FontAwesomeIcon className="rad1" icon={faPencilAlt} style={{ fontSize: 16, marginRight: 12 }} />
                    All
                </Radio.Button>
                <Radio.Button className="rad1 radioNew" value={2}>
                    <FontAwesomeIcon className="rad1" icon={faPencilAlt} style={{ fontSize: 16, marginRight: 12 }} />
                    Pending
                </Radio.Button>
                <Radio.Button className="rad3 radioNew" value={3}>
                    <FontAwesomeIcon className="rad3"  icon={faUniversity} style={{ fontSize: 16, marginRight: 12 }} />
                    Passed
                </Radio.Button>
                <Radio.Button className="rad2 radioNew" value={4}>
                    <FontAwesomeIcon className="rad2"  icon={faMoneyBillWave} style={{ fontSize: 16, marginRight: 12 }} />
                    Rejected
                </Radio.Button>
            </Radio.Group>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Search
            className='idSearch'
            placeholder="Search by Email"
            allowClear
            enterButton="Search"
            size="large"
            onSearch={this.onSearch}
            style={{ width: 320 }}
          />
        </div>
      </div>
        { identityList.length>0
        ?
        <div style={{ display: "flex", flexDirection: 'column', minHeight: tabHeight, width: '100%', 
        fontSize: 14, borderRadius: 3 }}>
            <Table indentSize={16} bordered columns={this.columns} dataSource={identityList} 
            pagination={false} />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
              <Pagination current={pageNumber} onChange={this.onPageChange} total={pageSize*10} />
            </div>
            <div style={{ display: 'flex', height: 100 }} />
        </div>
        :
        <div style={{ paddingTop: 40, height: tabHeight, width: '100%', textAlign: 'center' }}>
          <Text className="Agree" style={{ fontSize: 20, fontFamily: 'OpenSans-Bold', color: COLORS.yellow, lineHeight: 1.2 }}>
            {message}
          </Text>
        </div>    
        }
        {showModal && <IdUpdateModal currentObj={currentObj} sessionValue={this.props.sessionValue} 
        updateSingleIdentity={this.updateSingleIdentity} closeIdModal={this.closeIdModal} /> }
    </div>
  );
  }
}
